import { gql } from '@apollo/client';

export const SEAT_ASSIGNMENTS_FOR_TRIP = gql`
  query SeatAssignmentsForTrip($tripId: Int!) {
    seatAssignmentsForTrip(tripId: $tripId) {
      id
      seatNumber
      tripId
      playerId
      isCompanion
      cautionAmount
      cautionPaid
      cautionReturned
      player {
        id
        firstName
        lastName
        profile {
          pictureThumbnail
        }
      }
      createdAt
    }
  }
`;

export const TRIP_CAUTION_SUMMARY = gql`
  query TripCautionSummary($tripId: Int!) {
    tripCautionSummary(tripId: $tripId) {
      totalSeats
      cautionPaidCount
      cautionReturnedCount
      totalCollected
      totalReturned
      totalPending
    }
  }
`;

export const AVAILABLE_USERS_FOR_TRIP = gql`
  query AvailableUsersForTrip($tripId: Int!) {
    availableUsersForTrip(tripId: $tripId) {
      id
      firstName
      lastName
      status
      isParticipant
      profile {
        pictureThumbnail
      }
    }
  }
`;

export const AVAILABLE_PARTICIPANTS_FOR_TRIP = gql`
  query AvailableParticipantsForTrip($tripId: Int!) {
    availableParticipantsForTrip(tripId: $tripId) {
      id
      firstName
      lastName
      email
      profile {
        pictureThumbnail
        gender
        dateOfBirth
      }
    }
  }
`;

export const IS_TRANSPORTATION_AVAILABLE = gql`
  query IsTransportationAvailable(
    $transportationId: Int!
    $eventId: Int!
    $tripId: Int
  ) {
    isTransportationAvailable(
      transportationId: $transportationId
      eventId: $eventId
      tripId: $tripId
    )
  }
`;
